import { ImageColorFinderFlight, InfraredFlight, OrthoFlight } from "@nova/protobuf"
import { createFlightpathKML, Point } from "@nova/data-create-flight-path-kml"
import { JobStatusType, OrthoPalettes, ProjectWithMetadata } from "@nova/constants"
import { finished, outputFolder } from "@nova/util-s3"
import { normalize } from "@nova/util-strings"
import { config, getApiGatewayDomainForRegion } from "@nova/configuration"

export const getFlightpathKMLFromImages = (
    flight: InfraredFlight | OrthoFlight | ImageColorFinderFlight,
    showPlacemarks?: boolean
) => {
    if (flight.images.length === 0) return undefined
    const flightPathPoints = [...flight.images].sort((a, b) =>
        (a.takenAt || "") < (b.takenAt || "") ? -1 : a.takenAt === b.takenAt ? 0 : 1
    ) as Point[]
    const flightPathKml = createFlightpathKML(
        flight.name + " Flightpath",
        [flightPathPoints],
        showPlacemarks
    )
    return flightPathKml
}

// TODO
// export const getFlightpathKMLFromSRT
// export const getFlightpathKMLFromLiveVideoEvents
export const getOrthoArcTargetUrl = (
    flight: InfraredFlight | OrthoFlight,
    project: ProjectWithMetadata
) => {
    if (flight.job?.status !== JobStatusType.COMPLETED || flight.orthoBoundingBox.length !== 4)
        return undefined

    return `${config.get("domain")}/api/organization/${project.orgId}/project/${project.id}/chapter/unused/flight/${flight.id}/ortho.png`
}

export const getOrthoArcKml = (flight: InfraredFlight | OrthoFlight, resourceUrl: string) => {
    const time = Date.now().toString(36)

    return `<?xml version="1.0" encoding="UTF-8"?>
        <kml xmlns="http://www.opengis.net/kml/2.2">
        <GroundOverlay id="ortho-${time}">
            <name>${flight.name}</name>
            <Icon>
            <href>${resourceUrl}</href>
            </Icon>
            <LatLonBox>
            <north>${flight.orthoBoundingBox[2].latitude}</north>
            <south>${flight.orthoBoundingBox[0].latitude}</south>
            <east>${flight.orthoBoundingBox[0].longitude}</east>
            <west>${flight.orthoBoundingBox[2].longitude}</west>
            </LatLonBox>
        </GroundOverlay>
        </kml>`
}

export const getOrthoTakTiffKey = (
    flight: InfraredFlight | OrthoFlight,
    project: ProjectWithMetadata,
    extraFeature: string
) => {
    const extraFeaturesJSON = flight.job?.extraFeatures as string | undefined
    if (!extraFeaturesJSON) return undefined

    const extraFeatures = JSON.parse(extraFeaturesJSON.replaceAll("'", '"')) as string[]
    if (!extraFeatures.includes(extraFeature)) return undefined

    return finished(
        outputFolder(normalize(project.orgId), normalize(project.id), normalize(flight.id)),
        "tif",
        true
    )
}

interface TileUrlParams {
    palette?: OrthoPalettes
    isDemo?: boolean
    opacity?: number
    cogId?: string
}

export const getOrthoTileUrl = (
    flight: InfraredFlight | OrthoFlight,
    project: ProjectWithMetadata,
    opacity: number
) => {
    const options = { isDemo: !!flight.demoId, opacity } as TileUrlParams
    if ("orthoGradient" in flight) options.palette = flight.orthoGradient
    if (flight.cogOrtho?.fileId) options.cogId = flight.cogOrtho.fileId
    const query = new URLSearchParams(
        Object.entries(options).reduce(
            (acc, [key, value]) => {
                if (value !== undefined) acc[key] = value.toString()
                return acc
            },
            {} as Record<string, string>
        )
    ).toString()

    if (flight.job?.extraFeatures?.includes("cog"))
        return `${getApiGatewayDomainForRegion(project.region)}/org/${project.orgId}/project/${project.id}/flight/${flight.demoId || flight.id}/tile/%7Bz%7D/%7Bx%7D/%7By%7D${query ? "?" + query : ""}`
    return `${config.get("domain")}/api/organization/${project.orgId}/project/${project.id}/chapter/asd/flight/${flight.demoId || flight.id}/orthomosaicTiles/orthophoto_tiles/%7Bz%7D/%7Bx%7D/%7By%7D.png${query ? "?" + query : ""}`
}
